export enum NEW_YEAR_MODAL_CONTROL_VIEW {
    DECLINE = 'decline',
    ACCEPT = 'accept',
}
